import { fromJS } from "immutable";
import * as actionTypes from './actionTypes'
const initialState = fromJS({
  carouselData: {
    isLoading: true,
    data: [],
    error: ""
  }
});
const carouselComponent = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.carouselDataSuccessType:
      return state
        .setIn(["carouselData", "data"], action.payload)
        .setIn(["carouselData", "isLoading"], false);
    case actionTypes.carouselDataLoaderType:
      return state.setIn(["carouselData", "isLoading"], true);
    default:
      return state;
  }
};

export default carouselComponent;
